"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const BookingDetailModalContent_1 = __importDefault(require("../../Detail/BookingDetailModalContent"));
const BookingModalWrapper = styled_components_1.default.div `
  height: 100%;

  .collapse-btn {
    cursor: pointer;
    z-index: 12;

    &:hover {
      opacity: 1;
      background-color: #fff;
    }
  }
`;
const BookingDetailsModal = ({ booking, fetchNewBookings, onClose }) => (react_1.default.createElement(BookingModalWrapper, null,
    react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: "collapse-btn", onClick: () => {
            onClose();
        }, sx: {
            position: "absolute",
            right: 8,
            top: 8,
            color: "#000",
            zIndex: "2",
            backgroundColor: "#fff",
            opacity: "0.75",
        } },
        react_1.default.createElement(Close_1.default, null)),
    react_1.default.createElement(BookingDetailModalContent_1.default, { booking: booking, fetchNewBookings: fetchNewBookings })));
exports.default = BookingDetailsModal;
